import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Funciona si el examen en mi estado es solo en inglés?',
    a: 'Sí, precisamente por eso usamos el sistema RAM de reconocimiento visual de palabras en inglés.'
  }, {
    q: '¿Tengo que leer todo el manual del DMV?',
    a: 'No. Hemos filtrado el 80% de paja del manual para dejarte solo el 20% que realmente preguntan.'
  }, {
    q: '¿Sirve para la Clase B?',
    a: 'Esta guía está optimizada para Clase A (Combinación), que es la que más dinero genera, pero cubre las bases de la Clase B también.'
  }, {
    q: '¿Es seguro el pago?',
    a: 'Sí, usamos encriptación segura y recibes el acceso a tu PDF de inmediato tras la compra.'
  }];
  return <section className="py-24 bg-slate-900 px-4 sm:px-6 lg:px-8" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-31">
          <h2 className="text-4xl md:text-5xl font-oswald font-bold text-white uppercase mb-4" data-id="element-32">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-33">
          {faqs.map((faq, index) => {
          const isActive = activeIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`border rounded-xl overflow-hidden transition-colors duration-300 ${isActive ? 'bg-slate-800 border-amber-500/50' : 'bg-slate-800/50 border-slate-700 hover:border-slate-600'}`} data-id="element-34">
                <button onClick={() => setActiveIndex(isActive ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-35">
                  <span className={`font-oswald text-xl tracking-wide ${isActive ? 'text-amber-400' : 'text-white'}`} data-id="element-36">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 flex-shrink-0 transition-transform duration-300 ${isActive ? 'rotate-180 text-amber-400' : 'text-slate-400'}`} data-id="element-37" />
                </button>

                <AnimatePresence data-id="element-38">
                  {isActive && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-39">
                      <div className="px-6 pb-6 text-slate-300 text-lg leading-relaxed border-t border-slate-700/50 pt-4 mt-2" data-id="element-40">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}